import './style.css';
import React, { useState } from 'react';
import HrCard from '../../components/HrCard/index';
import ParkParkMy from '../../images/ParkParkMy.jpg';
import butters from '../../images/butters.jpg';
import Proudin from '../../images/Proudin.jpg';
import Future from '../../images/Future.jpg';
import Woojong from '../../images/Woojong.jpg';
import Hollis from '../../images/Hollis.jpg';
import pghpgh from '../../images/pghpgh.png';
import Eunji from '../../images/Eunji.png';
import Yeonsu from '../../images/yeonsu.png';
import Dasom from '../../images/Dasom.jpg';
import Nahee from '../../images/Nahee.jpg';
import Dexterity from '../../images/Dexterity.jpg';
import Taeyoon from '../../images/Taeyoon.jpg';
import AnHK from '../../images/AnHK.jpg';
import KHJ from '../../images/KHJ.jpg';
import BusinessChart from '../../images/businessChart.png';
import {
    IcCalendar, IcAward, IcPackage, IcBuilding,
    IcBook, IcHandshake, IcBulb, IcShield,
    IcCompass, IcNetwork, IcChat, IcCube, IcChart, IcCloud, IcUsers, IcDoc,
    IcMonitor, IcBrain, IcFactory,
    IcArrowRight, IcFlag,
    HeroCubeArt,
} from './Icons';

const HERO_STATS = [
    { Ic: IcCalendar, val: '2017',       label: '개인 사업 시작' },
    { Ic: IcAward,    val: '2024.08.14', label: '법인 설립' },
    { Ic: IcPackage,  val: '8+',         label: '제품 & 서비스' },
    { Ic: IcBuilding, val: 'B2B',        label: '엔터프라이즈 중심' },
];

const BELIEFS = [
    { Ic: IcBook,      title: '지식의 보존', desc: '흩어진 메모와 끊긴 회의록, 잊혀진 결정을 검색 가능한 자산으로 되살립니다.' },
    { Ic: IcHandshake, title: '협업의 연결', desc: '의사결정과 실행 사이의 거리를 줄여, 끊어지지 않는 협업의 흐름을 만듭니다.' },
    { Ic: IcBulb,      title: '창작의 확장', desc: '한 사람의 창작이 더 많은 사람에게, 더 오래 닿도록. 콘텐츠가 흩어지지 않을 자리를 만듭니다.' },
    { Ic: IcShield,    title: '신뢰의 기반', desc: '자체 인프라 위에서 운영합니다. 데이터를 빌리지 않고, 우리가 직접 책임집니다.' },
];

const PRODUCTS = [
    { Ic: IcCompass, color: '#a78bfa', name: 'SkyScribe',      desc: ['AI 기반 워십 음악 플랫폼.', '600곡 이상의 창작 찬양과 자동 편곡·반주를 제공합니다.'] },
    { Ic: IcNetwork, color: '#34d399', name: 'NodeMaster',     desc: ['트리 구조 기반의 지식 관리 도구.', '생각의 흐름을 끊김 없이 잇고 팀의 지식을 자산으로 축적합니다.'] },
    { Ic: IcChat,    color: '#01BCD6', name: 'AntsTalk',       desc: ['AI 에이전트와 벡터 DB를 내장한 엔터프라이즈 메신저.', '대화가 그대로 업무 자동화로 이어집니다.'] },
    { Ic: IcCube,    color: '#f87171', name: 'AR대탈출',        desc: ['AR 기반 교육용 탈출 게임.', '학습을 공간 체험으로 바꿔 몰입도와 기억 정착도를 끌어올립니다.'] },
    { Ic: IcChart,   color: '#60a5fa', name: 'GanttChart',     desc: ['간트차트 기반 프로젝트 관리 도구.', '일정·자원·실행 흐름을 한 화면에서 시각화합니다.'] },
    { Ic: IcCloud,   color: '#0ea5e9', name: 'Skynet Cloud',   desc: ['자체 운영 클라우드 인프라.', '데이터 주권과 비용 효율, 운영 안정성을 동시에 추구합니다.'] },
    { Ic: IcUsers,   color: '#f97316', name: 'MDM (기준정보관리)', desc: ['동적 계층 구조 기반 기준정보 관리.', '작은 조직도 대기업 수준의 데이터 표준을 가질 수 있게 합니다.'] },
    { Ic: IcDoc,     color: '#fbbf24', name: '견적 자동화',      desc: ['개발 견적을 분 단위로 산출.', '초기 창업가와 외주 개발팀의 견적 작업을 자동화합니다.'] },
];

const TIMELINE = [
    { Ic: IcUsers,    year: '2017',         title: '사람을 키운 것이, 회사의 시작이었습니다',
      body: '대표 용수현은 개발자로 자리를 잡은 뒤, 진로가 막막했던 또래들에게 코딩을 가르쳐 자립을 도왔습니다. 한 명, 두 명 모여 만들어진 네트워크가 점점 커졌고 — 그 인연이 곧 앤츠네스트라는 이름의 원형이 되었습니다.' },
    { Ic: IcDoc,      year: '2018~2019',    title: '현장 운영의 감각을 다진 시기',
      body: '초기에는 IT 유지보수와 소규모 SI로 운영의 기반을 다졌습니다. 작은 조직이라도 멈추지 않는 운영, 직접 손에 닿는 서비스 — 이때 다진 감각이 지금 모든 제품의 안정성에 대한 기준이 되었습니다.' },
    { Ic: IcMonitor,  year: '2019~2023',    title: '소프트웨어 회사로의 본격 전환',
      body: '동료들과 뜻을 모아 자체 소프트웨어 개발로 방향을 전환했습니다. 대기업 SI로 도메인 깊이를 다지는 동시에, 우리 손으로 운영할 제품을 하나씩 쌓아 가기 시작한 시기입니다.' },
    { Ic: IcFactory,  year: '2020~현재',     title: '엔터프라이즈 깊이와 자체 제품의 동시 성장',
      body: '반도체·MES 등 대기업 현장에서 엔터프라이즈 도메인 개발을 수행하며 기술 깊이를 더했습니다. 그 사이 자체 제품을 차근차근 출시해, 지금의 8개 제품 생태계가 만들어졌습니다.' },
    { Ic: IcFlag,     year: '2024.08.14',   title: '법인 설립 — 다음 시대로의 출발선', current: true,
      body: '8년간 운영해온 제품과 인연을 그대로 안고, 주식회사 앤츠네스트라는 이름을 갖게 됐습니다. 처음을 시작하는 것이 아니라, 다음을 시작하기 위한 자리를 만든 셈입니다.' },
];

const TECH = [
    { Ic: IcCube,    title: 'AR/VR 콘텐츠 제작', items: ['Unity / C#', 'Blender', 'MagicaCloth 2', 'AutoRig Pro', 'Meshy AI 파이프라인'] },
    { Ic: IcMonitor, title: '풀스택 웹',         items: ['Node.js · Express', 'React · React Native', 'PostgreSQL'] },
    { Ic: IcBrain,   title: 'AI / ML 통합',      items: ['Claude API', 'LangGraph 에이전트', 'Milvus · pgvector', '벡터 DB 검색', '자체 LLM 동작 원리 연구'] },
    { Ic: IcCloud,   title: '클라우드 인프라',     items: ['iwinv · Hetzner', '자체 운영 클라우드', 'PM2 · Docker 운영'] },
    { Ic: IcFactory, title: '엔터프라이즈 도메인',  items: ['MES · 반도체 SI', 'Java · Spring', 'Oracle · MSSQL', 'C# · WPF'] },
];

const KPI = [
    { Ic: IcPackage,  big: '8',    suffix: '',  label: '자체 SaaS 제품',     sub: '직접 개발·운영' },
    { Ic: IcCompass,  big: '600',  suffix: '+', label: '누적 창작 콘텐츠',   sub: 'SkyScribe 워십곡' },
    { Ic: IcUsers,    big: '16K',  suffix: '+', label: '누적 활성 사용자',   sub: '서비스 통합' },
    { Ic: IcNetwork,  big: '15',   suffix: '+', label: '자체 도메인·엔드포인트', sub: '서브도메인 운영' },
    { Ic: IcCalendar, big: '8',    suffix: '년+', label: '누적 운영 노하우', sub: '2017 ~ 현재' },
    { Ic: IcCloud,    big: '24/7', suffix: '', label: '자체 클라우드 가동', sub: '모니터링·알람 시스템' },
];

const STRENGTHS = [
    { Ic: IcCube,      title: '직접 만드는 회사',
      desc: '외주에 기대지 않습니다. 기획·디자인·개발·운영까지 모든 단계를 내부에서 처리합니다. 8개의 자체 SaaS가 그 증거입니다.' },
    { Ic: IcHandshake, title: '깊이로 다진 도메인',
      desc: '소규모 운영부터 반도체 대기업의 엔터프라이즈 도메인까지 — 운영의 모든 층위를 직접 다뤄온 경험이 제품의 안정성으로 이어집니다.' },
    { Ic: IcShield,    title: '자체 인프라, 데이터 주권',
      desc: '퍼블릭 클라우드에 종속되지 않습니다. 자체 운영 클라우드 위에서 — 안정성, 비용, 데이터 주권 모두 우리가 직접 통제합니다.' },
    { Ic: IcBrain,     title: 'AI를 다루는 깊이',
      desc: 'API를 호출하는 회사가 아닙니다. LangGraph 에이전트, 벡터 DB, 자체 RAG 파이프라인을 직접 설계해 운영합니다.' },
];

export default function Company() {
    const [tab, setTab] = useState('company');

    return (
        <div className="CompanyContents">
            <div className="HomeContainer">
                <div className="CompanyTopTxt">
                    <div className="CompanyTopEyebrow">ABOUT ANTSNEST</div>
                    <h1>{tab === 'company' ? 'Company' : 'About Us'}</h1>
                    <p className="CompanyTopLead">
                        {tab === 'company'
                            ? '앤츠네스트(ANTSNEST)는 사람이 남긴 지식과 창작의 흔적이 다음 시대로 이어지도록, 도구와 인프라를 직접 만들고 운영하는 회사입니다.'
                            : '앤츠네스트라는 이름의 원형이 되어준 사람들 — 함께 일했던 협력자, 그리고 지금도 인연이 이어지고 있는 동료들을 소개합니다.'}
                    </p>
                    {tab === 'company' && (
                        <div className="CompanyTopMeta">
                            <span>EST. 2017</span>
                            <span className="dot">·</span>
                            <span>법인 2024.08.14</span>
                            <span className="dot">·</span>
                            <span>8개 자체 SaaS</span>
                            <span className="dot">·</span>
                            <span>B2B Enterprise</span>
                        </div>
                    )}
                </div>

                <div className="CompanyTabs">
                    <button type="button"
                        className={'CompanyTab' + (tab === 'company' ? ' active' : '')}
                        onClick={() => setTab('company')}
                    >회사 소개</button>
                    <button type="button"
                        className={'CompanyTab' + (tab === 'about' ? ' active' : '')}
                        onClick={() => setTab('about')}
                    >About Us</button>
                </div>

                {tab === 'company' && (
                    <div className="CompanyIntro">
                        {/* HERO */}
                        <section className="cmp-hero">
                            <div className="cmp-hero-inner">
                                <div className="cmp-hero-text">
                                    <span className="cmp-tag">회사 소개</span>
                                    <h2 className="cmp-hero-title">흩어지는 모든 것을,<br/>다음으로 잇습니다.</h2>
                                    <p className="cmp-hero-desc">
                                        디지털은 빠르고, 그래서 더 쉽게 사라집니다.<br/>
                                        앤츠네스트는 사람이 남긴 지식 · 협업 · 창작의 흔적이<br/>
                                        다음 시대로 이어지도록, 도구와 인프라를 만드는 회사입니다.<br/>
                                        <strong style={{color:'#fff'}}>8개의 자체 SaaS</strong>와 <strong style={{color:'#fff'}}>자체 클라우드</strong>, 자체 AI 위에서 — 우리 손으로 직접 운영합니다.
                                    </p>
                                    <div className="cmp-hero-stats">
                                        {HERO_STATS.map(s => (
                                            <div className="cmp-stat" key={s.label}>
                                                <span className="cmp-stat-ico"><s.Ic size={22}/></span>
                                                <div>
                                                    <div className="cmp-stat-val">{s.val}</div>
                                                    <div className="cmp-stat-label">{s.label}</div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="cmp-hero-art">
                                    <HeroCubeArt className="cmp-hero-svg"/>
                                </div>
                            </div>
                        </section>

                        {/* 숫자로 보는 앤츠네스트 */}
                        <section className="cmp-block">
                            <div className="cmp-block-head cmp-center">
                                <span className="cmp-tag">지금, 운영 중인 것들</span>
                                <h2 className="cmp-h2">비전은 멀지만, 우리가 이미 닿은 곳.</h2>
                                <p className="cmp-block-desc">앤츠네스트의 다음을 향한 발걸음은, 다음의 숫자들 위에서 시작됩니다.</p>
                            </div>
                            <div className="cmp-kpi-grid">
                                {KPI.map(k => (
                                    <div className="cmp-kpi" key={k.label}>
                                        <div className="cmp-kpi-ico"><k.Ic size={22}/></div>
                                        <div className="cmp-kpi-big">
                                            {k.big}<span className="suffix">{k.suffix}</span>
                                        </div>
                                        <div className="cmp-kpi-label">{k.label}</div>
                                        <div className="cmp-kpi-sub">{k.sub}</div>
                                    </div>
                                ))}
                            </div>
                        </section>

                        {/* 우리가 믿는 것 — 좌측 인용 + 우측 4카드 */}
                        <section className="cmp-block cmp-beliefs">
                            <div className="cmp-beliefs-grid">
                                <div className="cmp-beliefs-lead">
                                    <span className="cmp-tag">우리가 믿는 것</span>
                                    <h2 className="cmp-quote">&ldquo;기록되지 않으면, 사라집니다.&rdquo;</h2>
                                    <p className="cmp-block-desc">
                                        지식과 협업, 창작의 흔적은 어디서나 만들어지지만<br/>
                                        어디서도 보존되지 않으면 곧 잊혀집니다.<br/>
                                        앤츠네스트는 이 사라짐을 막는 도구를 만듭니다.<br/>
                                        흩어진 기록을 모으고, 사람을 잇고,<br/>
                                        신뢰할 수 있는 인프라 위에 안전하게 보관합니다.
                                    </p>
                                </div>
                                <div className="cmp-belief-grid">
                                    {BELIEFS.map(b => (
                                        <div className="cmp-belief" key={b.title}>
                                            <div className="cmp-belief-ico"><b.Ic size={28}/></div>
                                            <h3>{b.title}</h3>
                                            <p>{b.desc}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </section>

                        {/* 우리가 만드는 것 */}
                        <section className="cmp-block">
                            <div className="cmp-block-head cmp-center">
                                <span className="cmp-tag">우리가 만드는 것</span>
                                <h2 className="cmp-h2">8개의 제품, 하나의 생태계</h2>
                                <p className="cmp-block-desc">각각이 독립된 SaaS이자, 데이터와 워크플로우로 서로 이어지는 하나의 플랫폼입니다.</p>
                            </div>
                            <div className="cmp-product-grid">
                                {PRODUCTS.map(p => (
                                    <div key={p.name} className="cmp-product" style={{ '--p-color': p.color }}>
                                        <div className="cmp-product-ico"><p.Ic size={26} stroke="#fff"/></div>
                                        <div className="cmp-product-name">{p.name}</div>
                                        <p>{p.desc.map((l, i) => <React.Fragment key={i}>{l}<br/></React.Fragment>)}</p>
                                    </div>
                                ))}
                            </div>
                        </section>

                        {/* 우리가 걸어온 길 */}
                        <section className="cmp-block">
                            <div className="cmp-block-head cmp-center">
                                <span className="cmp-tag">우리가 걸어온 길</span>
                                <h2 className="cmp-h2">사람에서 출발해, 8년을 함께 걸어온 길</h2>
                            </div>
                            <ol className="cmp-timeline">
                                {TIMELINE.map(t => (
                                    <li key={t.year} className={t.current ? 'cmp-tl-current' : ''}>
                                        <div className="cmp-tl-marker"><t.Ic size={18} stroke="#01BCD6"/></div>
                                        <div className="cmp-tl-year">{t.year}</div>
                                        <div className="cmp-tl-body">
                                            <h4>{t.title}</h4>
                                            <p>{t.body}</p>
                                        </div>
                                    </li>
                                ))}
                            </ol>
                        </section>

                        {/* 기술 역량 */}
                        <section className="cmp-block">
                            <div className="cmp-block-head cmp-center">
                                <span className="cmp-tag">기술 역량</span>
                                <h2 className="cmp-h2">현장에서 검증된 풀스택 기술 스택</h2>
                                <p className="cmp-block-desc">대기업 SI와 자체 SaaS 운영을 동시에 수행하며 다져진 풀스택·AI·클라우드 역량입니다.</p>
                            </div>
                            <div className="cmp-tech-grid">
                                {TECH.map(t => (
                                    <div className="cmp-tech" key={t.title}>
                                        <div className="cmp-tech-ico"><t.Ic size={28}/></div>
                                        <h4>{t.title}</h4>
                                        <ul>
                                            {t.items.map(i => <li key={i}>{i}</li>)}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </section>

                        {/* 우리가 다른 이유 */}
                        <section className="cmp-block">
                            <div className="cmp-block-head cmp-center">
                                <span className="cmp-tag">우리가 다른 이유</span>
                                <h2 className="cmp-h2">왜 앤츠네스트인가</h2>
                                <p className="cmp-block-desc">규모보다 깊이, 속도보다 지속을 택했습니다.</p>
                            </div>
                            <div className="cmp-strength-grid">
                                {STRENGTHS.map(s => (
                                    <div className="cmp-strength" key={s.title}>
                                        <div className="cmp-strength-ico"><s.Ic size={26}/></div>
                                        <h4>{s.title}</h4>
                                        <p>{s.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </section>

                        {/* 하단 3분할 */}
                        <section className="cmp-footer-row">
                            <div className="cmp-info-card">
                                <h3>회사 정보</h3>
                                <dl>
                                    <div><dt>법인명</dt><dd>주식회사 앤츠네스트<br/>(ANTSNEST Co., Ltd.)</dd></div>
                                    <div><dt>대표이사</dt><dd>용수현</dd></div>
                                    <div><dt>법인 설립일</dt><dd>2024년 8월 14일</dd></div>
                                    <div><dt>법인 소재지</dt><dd>경기도 용인시</dd></div>
                                    <div><dt>업종</dt><dd>솔루션 · SI · ERP · CRM,<br/>클라우드 기반 AR · AI 플랫폼 개발</dd></div>
                                    <div><dt>사업 영역</dt><dd>VR/AR 교육 플랫폼, AI API 활용 개발,<br/>클라우드 시스템 구축 · 운영, SI/SM 외주 개발</dd></div>
                                </dl>
                            </div>
                            <div className="cmp-vision-card">
                                <h3>우리가 가는 곳</h3>
                                <p>
                                    한 분기의 매출보다, 10년 뒤의 사용자 명단이 더 중요한 회사가 되고자 합니다.<br/>
                                    누군가의 일상에 자연스럽게 스며드는 도구가 되고,<br/>
                                    이제 막 시작하는 창업가의 첫 인프라가 되며,<br/>
                                    다음 세대에게 학습의 즐거움을 돌려주는 회사 —<br/>
                                    그곳이 우리가 가고자 하는 자리입니다.
                                </p>
                                <p className="cmp-vision-tag">
                                    빠르게 가는 회사보다,<br/>
                                    멀리 닿는 회사를 만들겠습니다.
                                </p>
                                <div className="cmp-vision-sign">
                                    ANTSNEST Co., Ltd.<br/>
                                    함께, 그리고 멀리.
                                </div>
                            </div>
                            <div className="cmp-partner-card">
                                <h3>다음 8년을<br/>함께 만들 파트너를 찾습니다</h3>
                                <p>B2B 도입 · SI 협업 · 솔루션 라이선싱.<br/>앤츠네스트의 제품과 인프라가<br/>함께할 다음 파트너를 기다리고 있습니다.</p>
                                <a href="/Contact" className="cmp-partner-btn">
                                    문의하기 <IcArrowRight size={16}/>
                                </a>
                            </div>
                        </section>
                    </div>
                )}

                {tab === 'about' && (
                <>
                <div className='HrCardContainer'>
                    <HrCard Photo={Dexterity} Name="용수현" Work="Project Leader" Title="프로젝트 그룹 대표" Work2="Rnd 개발,인프라 담당" Email="ysh1103korea@antsnest.co.kr"/>
                    <HrCard Photo={Proudin}   Name="박상욱" Work="Project Leader" Title="프로젝트 그룹 대표" Work2="서버 및 데이터베이스 담당" Email="psw88@antsnest.co.kr"/>
                    <HrCard Photo={butters}   Name="최용호" Work="Project Member" Title="Web&App Developer" Work2="Spa 웹앱 개발 담당" Email="butters88@naver.com"/>
                    <HrCard Photo={ParkParkMy} Name="박명준" Work="Project Member" Title="Application Developer" Work2="Java / .Net 응용 개발" Email="ParkParkMy@antsnest.co.kr"/>
                    <HrCard Photo={Future}    Name="이혜림" Work="Project Member" Title="Application Developer" Work2="WPF /.Net 응용 개발" Email="gPfla8966@gmail.com"/>
                    <HrCard Photo={Woojong}   Name="진우종" Work="Project Member" Title="Web&App Developer" Work2="Spa 웹앱 개발 담당" Email="woojong67@naver.com"/>
                    <HrCard Photo={Hollis}    Name="김연주" Work="Project Member" Title="3D Designer" Work2="3D 모델링 리소스" Email="duswn9211@naver.com"/>
                    <HrCard Photo={pghpgh}    Name="박경화" Work="Project Member" Title="리눅스,데이터베이스" Work2="인프라 구축 설계" Email="rudghk435@naver.com"/>
                    <HrCard Photo={Eunji}     Name="이은지" Work="Project Member" Title="App&Web Developer" Work2="프론트&백엔드 개발" Email="ieunji470@antsnest.co.kr"/>
                    <HrCard Photo={Yeonsu}    Name="이연수" Work="Project Member" Title="App&Web Developer" Work2="프론트&백엔드 개발" Email="djfksdl@antsnest.co.kr"/>
                    <HrCard Photo={Dasom}     Name="김다솜" Work="Project Member" Title="Marketing&UI/UX Designer" Work2="마케팅, UI/UX디자인" Email="som1213@antsnest.co.kr"/>
                    <HrCard Photo={Nahee}     Name="김나희" Work="Project Member" Title="Component Developer" Work2="FrameWork Architecture" Email="madnarii@antsnest.co.kr"/>
                    <HrCard Photo={Taeyoon}   Name="허태윤" Work="Project Member" Title="Fa devops Developer" Work2="FrameWork Architecture" Email="benuze@antsnest.co.kr"/>
                    <HrCard Photo={AnHK}      Name="안형기" Work="Project Member" Title="App&Web Developer" Work2="프론트&백엔드 개발" Email="gudrl96@antsnest.co.kr"/>
                    <HrCard Photo={KHJ}       Name="김형진" Work="Project Member" Title="App&Web Developer" Work2="기술강의&PC Repair" Email="khjin0313@antsnest.co.kr"/>
                </div>
                <div className="CompanyChartTxt">
                    <h1>Business Organization Chart</h1>
                    <img src={BusinessChart} alt="organization chart" />
                </div>
                </>
                )}
            </div>
        </div>
    );
}
